// GA's own session timeout: a browser idle this long arrives on a new visit.
const VISIT_IDLE_TIMEOUT_MS = 30 * 60 * 1000;
const LAST_ACTIVITY_STORAGE_KEY = "ee_last_activity_at";

/** Records browser activity; localStorage so every tab of the browser shares one visit. */
export const markVisitActivity = (): void => {
  try {
    window.localStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, String(Date.now()));
  } catch {
    // Storage blocked: isNewVisit then reports no new visit, which only costs a referrer touch.
  }
};

/**
 * Whether this page load starts a new visit. Returns from OAuth, Stripe or an account-connect
 * flow come back within minutes with the provider as referrer, and must not read as a new visit.
 */
export const isNewVisit = (): boolean => {
  try {
    const lastActivityAt = Number(window.localStorage.getItem(LAST_ACTIVITY_STORAGE_KEY));
    return !(lastActivityAt > 0) || Date.now() - lastActivityAt > VISIT_IDLE_TIMEOUT_MS;
  } catch {
    return false;
  }
};
